import { IconSet } from '@postscript/components';
import { NavMenuItem } from 'components/navigation/NavMenu';
import { useMemo } from 'react';
import { User } from 'types';
import { useAccountMenuItems } from './useAccountMenuItems';
import { useAcquisitionsMenuItems } from './useAcquisitionsMenuItems';
import { useAdminMenuItems } from './useAdminMenuItems';
import { useBrandCenterMenuItems } from './useBrandCenterMenuItems';
import { useDataInsightsMenuItems } from './useDataInsightsMenuItems';
import { useIntegrationsMenuItems } from './useIntegrationsMenuItems';
import { useMessagingMenuItems } from './useMessagingMenuItems';
import { usePsPayMenuItems } from './usePsPayMenuItems';
import { useSmsSalesMenuItems } from './useSmsSalesMenuItems';

export const useBaseMenu = (user: User): NavMenuItem[] => {
  const smsSalesMenuItems = useSmsSalesMenuItems();
  const messagingMenuItems = useMessagingMenuItems();
  const acquisitionsMenuItems = useAcquisitionsMenuItems();
  const dataInsightsMenuItems = useDataInsightsMenuItems();
  const brandCenterMenuItems = useBrandCenterMenuItems();
  const psPayMenuItems = usePsPayMenuItems();
  const integrationsMenuItems = useIntegrationsMenuItems();
  const accountMenuItems = useAccountMenuItems(user);
  const adminMenuItems = useAdminMenuItems();

  return useMemo(() => {
    return [
      {
        id: 'dashboard',
        label: 'Dashboard',
        icon: IconSet.Dashboard,
        isLoading: false,
        link: '/',
        ariaLabelledBy: 'nav-dashboard-title',
      },
      ...smsSalesMenuItems,
      ...messagingMenuItems,
      ...acquisitionsMenuItems,
      ...dataInsightsMenuItems,
      ...brandCenterMenuItems,
      ...psPayMenuItems,
      ...integrationsMenuItems,
      ...accountMenuItems,
      ...adminMenuItems,
    ];
  }, [
    smsSalesMenuItems,
    messagingMenuItems,
    acquisitionsMenuItems,
    dataInsightsMenuItems,
    brandCenterMenuItems,
    psPayMenuItems,
    integrationsMenuItems,
    accountMenuItems,
    adminMenuItems,
  ]);
};
